import { createFileRoute } from "@tanstack/react-router";
import { Suspense } from "react";
import { PageTransition } from "@/components/PageTransition";
import Index from "@/pages/Index";

export const Route = createFileRoute("/")({
  head: () => ({
    meta: [
      {
        title: "Website Design, SEO & Ads for Service Businesses | The Outpost",
      },
      {
        name: "description",
        content:
          "The Outpost builds websites, local SEO, and ads for service businesses. 100+ sites built, avg +300% traffic. Based in Bentonville, AR. Get a free SEO audit.",
      },
      {
        name: "keywords",
        content:
          "website design, SEO, local SEO, Google Business Profile, paid advertising, lead generation, service businesses, Bentonville AR",
      },
      { property: "og:title", content: "The Outpost Creative" },
      {
        property: "og:description",
        content:
          "Websites, local SEO, and ads for service businesses. 100+ sites built, avg +300% traffic. Based in Bentonville, AR.",
      },
      { property: "og:type", content: "website" },
      {
        property: "og:image",
        content:
          "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6a2b20ec983b31ac4a594118.png",
      },
      { property: "og:url", content: "https://theoutpost.agency/" },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:image",
        content:
          "https://assets.cdn.filesafe.space/rizeckkMPBYZT9pK9UjX/media/6a2b20ec983b31ac4a594118.png",
      },
      { name: "twitter:title", content: "The Outpost Creative" },
      {
        name: "twitter:description",
        content:
          "Websites, local SEO, and ads for service businesses. 100+ sites built, avg +300% traffic.",
      },
    ],
    links: [{ rel: "canonical", href: "https://theoutpost.agency/" }],
  }),
  component: IndexRoute,
});

function IndexRoute() {
  return (
    <PageTransition>
      <Suspense fallback={<div className="min-h-screen bg-background" />}>
        <Index />
      </Suspense>
    </PageTransition>
  );
}
